exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".skills iframe {\n  width: calc(100% - 30px);\n  transition: all .2s; }\n\n.skills.hidden iframe {\n  visibility: hidden; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Skills/index.scss
// module id = 1112
// module chunks = 0